import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent {
  token = this.route.snapshot.queryParams['token'] as string | undefined ?? '';
  password = '';
  confirmPassword = '';
  errorMessage = '';
  isSubmitting = false;

  constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
  }

  onSubmit(): void {
    if (!this.token) {
      this.errorMessage = 'Reset token is missing';
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      return;
    }

    this.errorMessage = '';
    this.isSubmitting = true;

    this.authService.resetPassword(this.token, this.password).subscribe({
      next: () => {
        void this.router.navigate(['/login'], {
          queryParams: {
            reset: 'complete',
          },
        });
      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage = error.error?.message ?? 'Unable to reset password';
        this.isSubmitting = false;
      },
    });
  }
}
